import React from "react";
import styles from "./DialerTabs.module.css";

const KeypadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    {[5, 12, 19].map((y) =>
      [5, 12, 19].map((x) => <circle key={`${x}-${y}`} cx={x} cy={y} r="1.9" />)
    )}
  </svg>
);

const RecentsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 7.5V12l3 1.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const ContactsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M5 19c0-3.04 3.13-5.5 7-5.5s7 2.46 7 5.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const TABS = [
  { key: "keypad", label: "Keypad", Icon: KeypadIcon },
  { key: "recents", label: "Recents", Icon: RecentsIcon },
  { key: "contacts", label: "Contacts", Icon: ContactsIcon },
];

const DialerTabs = ({ active, onChange, hidden = [] }) => (
  <div className={styles.tabs}>
    {TABS.filter((t) => !hidden.includes(t.key)).map(({ key, label, Icon }) => (
      <button
        key={key}
        type="button"
        className={`${styles.tab} ${active === key ? styles.active : ""}`}
        onClick={() => onChange(key)}
        aria-current={active === key ? "page" : undefined}
      >
        <Icon />
        <span>{label}</span>
      </button>
    ))}
  </div>
);

export default DialerTabs;
